<div class="mobile-menu-overlay fixed inset-0 z-50 flex flex-col lg:hidden" [class.open]="isOpen">
  <div class="bg-[#E30613] h-16.25 px-2.5 flex items-center justify-between shrink-0">
    <img src="https://deportivo-municipal.s3.us-east-2.amazonaws.com/assets/logo2.png" alt="Escudo Municipal" class="w-13.75 h-13.75 object-contain" />
    <button (click)="onClose()"
      class="text-white p-2 flex items-center justify-center transition-colors hover:text-white/80"
      aria-label="Cerrar menú">
      <svg width="28" height="28" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <div class="flex-1 overflow-y-auto bg-gris-claro" style="padding: 34px 14px;">
    <div class="flex flex-col gap-8 w-full text-azul-profundo">

      <div class="flex flex-col gap-7">

        <a routerLink="/history" (click)="onClose()" class="menu-item">
          Historia
        </a>

        <a routerLink="/news" (click)="onClose()" class="menu-item">
          Noticias
        </a>

        <a routerLink="/academy" (click)="onClose()" class="menu-item">
          Academia
        </a>

        <button type="button" (click)="onToggleSubmenu('plantel')" class="menu-item text-left"
          [attr.aria-expanded]="mobileSubmenu === 'plantel'" aria-controls="mobile-plantel-links">
          Planteles
        </button>
        @if (mobileSubmenu === 'plantel') {
          <div id="mobile-plantel-links" class="flex flex-col gap-5 pl-4">
            @for (column of plantelMenuConfig.columns; track column.title) {
              @for (link of column.links; track link.label) {
                <a [routerLink]="link.url" [queryParams]="link.queryParams" [fragment]="link.fragment"
                  (click)="onClose()" class="font-display text-xl text-azul-profundo">
                  {{ link.label }}
                </a>
              }
            }
          </div>
        }

        <a routerLink="/store" (click)="onClose()" class="menu-item">
          Tienda
        </a>

        <a routerLink="/fixture" (click)="onClose()" class="menu-item">
          Fixture
        </a>

        <a routerLink="/tickets" (click)="onClose()" class="menu-item">
          Ticketera
        </a>

        <a routerLink="/abono-edil" (click)="onClose()" class="menu-item">
          Abono Edil
        </a>

        <a routerLink="/sponsors" (click)="onClose()" class="menu-item">
          La Camiseta de Todos
        </a>

      </div>

      <div class="h-px w-full bg-azul-profundo"></div>

      @if (usuario(); as sesion) {
        <button type="button" (click)="signOut()"
          class="flex items-center gap-2.5 no-underline hover:opacity-80 transition-opacity bg-transparent border-0 p-0 cursor-pointer text-left">
          <span class="w-8 h-8 rounded-full shrink-0 flex items-center justify-center text-white leading-none uppercase"
            [style.background-color]="sesion.avatarColor">
            {{ sesion.nombre.charAt(0) }}
          </span>
          <span class="font-display text-[25px] leading-5 text-azul-profundo uppercase">
            Cerrar sesión
          </span>
        </button>
      } @else {
        <a routerLink="/login" (click)="onClose()"
          class="flex items-center gap-2.5 no-underline hover:opacity-80 transition-opacity">
          <span class="session-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="currentColor" class="text-black">
              <path
                d="M320 312C386.3 312 440 258.3 440 192C440 125.7 386.3 72 320 72C253.7 72 200 125.7 200 192C200 258.3 253.7 312 320 312zM290.3 368C191.8 368 112 447.8 112 546.3C112 562.7 125.3 576 141.7 576L498.3 576C514.7 576 528 562.7 528 546.3C528 447.8 448.2 368 349.7 368L290.3 368z" />
            </svg>
          </span>
          <span class="font-display text-[25px] leading-5 text-azul-profundo uppercase">
            Iniciar sesión
          </span>
        </a>
      }

    </div>
  </div>

</div>
